<template>
  <div class="d-flex">
    <div :class="classItem(item)" v-for="(item, i) in items" :key="i">
      <a v-if="item.locale" class="nav-link" :href="`/${item.locale}/${item.url}`">{{ item.label|globalTranslate }}</a>
      <a v-if="!item.locale" class="nav-link" :href="`/${item.url}`">{{ item.label|globalTranslate }}</a>
    </div>
  </div>
</template>

<script>

export default {
  name: "Menu",
  methods: {
    classItem(item) {
      const klasses = ["nav-item"];
      if (item.class) {
        klasses.push(item.class);
      }

      return klasses;
    }
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.nav-item .nav-link {
  color: #555555;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 16px;
}

.nav-item .nav-link,
.nav-item span {
  padding: 0 8px;
}

.nav-item {
  line-height: 70px;
}

.reserver {
  background-color: #d90000;
  cursor: pointer;
}

.reserver > a {
  color: white !important;
}

.reserver:hover {
  background-color: #555555 !important;
}
</style>
